import Big from 'big.js';
export const bankRound = (num, decimalPlaces) => {
  const factor = 10 ** decimalPlaces;
  return Math.round((num + Number.EPSILON) * factor) / factor;
};

export const parseNumToPercentage = (number, fixed = 1) => {
  const bigNumber = new Big(number * 100);
  if (bigNumber.toNumber() === 100) {
    return '100%';
  }
  return bigNumber.toFixed(fixed) + '%';
};
